import { Super } from './super.model';

export class Notecriterias extends Super<Notecriterias> {

    public name: string;
    public description: string;
    public max_rate:number;
    public min_rate:number;
    public weigth:number;
    public slug: string;
    

    
}